<ng-container *transloco="let t" class="container">
  <div class="p-2">
    <div class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      </button>
    </div>
    <form [formGroup]="inputForm">
      <div class="modal-body">
        <app-textarea formControlName="chipNumbers" rows="5" label="race.management.competitors.assign.chip.numbers.input"/>
      </div>
    </form>
    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <div class="me-3">
          <app-button (onClick)="onDismissClick()" [label]="dismissButtonTitle ?? t('app.common.cancel')"
                      [btnClass]="'btn-grey text-uppercase'"></app-button>
        </div>
        <app-button (onClick)="onConfirmClick()" [label]="confirmButtonTitle ?? t('app.common.confirm')"
                    [btnClass]="'btn-primary-red text-uppercase'"
                    [isDisabled]="!inputForm.valid || !inputForm.touched"></app-button>
      </div>
    </div>
  </div>
</ng-container>
